import dayjs from 'dayjs'

const RESOURCE_CACHE_NAME = 'resources.cache'
const RESOURCE_CACHE_VALIDITY = 60 // minutes

export class Cache {

	static cleanupExpiredResources () {

		const allResources = window.localStorage.getItem(RESOURCE_CACHE_NAME) ? JSON.parse(window.localStorage.getItem(RESOURCE_CACHE_NAME)) : {}
		let hasChanges = false

		Object.keys(allResources).forEach(key => {
			const resource = allResources[key]
			if (resource.statestamp) {
				const minutesDiff = dayjs().diff(dayjs.unix(resource.statestamp), 'minute')
				if (minutesDiff >= RESOURCE_CACHE_VALIDITY) {
					delete allResources[key]
					hasChanges = true
				}
			}
		})

		if (hasChanges) {
			window.localStorage.setItem(RESOURCE_CACHE_NAME, JSON.stringify(allResources))
		}

		return allResources

	}

	static get resources () {

		return Cache.cleanupExpiredResources()

	}

	static extend (data) {

		window.localStorage.setItem(RESOURCE_CACHE_NAME, JSON.stringify({
			...Cache.resources,
			...data
		}))

	}

	static clear () {

		window.localStorage.removeItem(RESOURCE_CACHE_NAME)

	}

}

export class Resource {

	constructor (resource, customer_id) {

		this.data = resource
		this.customer_id = customer_id

	}

	get statestamp () {

		return (this.data.hasOwnProperty('statestamp') ? this.data.statestamp : false)

	}

	get validity () {

		return (this.statestamp ? dayjs().diff(dayjs.unix(this.statestamp), 'minute') : false)

	}

	get owner () {

		return (this.data.hasOwnProperty('customer_id') ? this.data.customer_id : false)

	}

	get isValid () {

		return (Number.isInteger(this.validity) && this.validity < RESOURCE_CACHE_VALIDITY && this.owner && this.owner === this.customer_id)

	}

}
